export default {
  NavigationController: require('./navigation_controller.jsx').default,
  Screens: {
    Message: require('./screens/message.jsx').default,
    Summary: require('./screens/summary.jsx').default,
  },
};
